const getHotelRate = ({
  hotel,
  roomType,
  mealPlan,
}) => {

  const seasonalRates =
    hotel.roomOptions || [];

  const selectedRoom =
    seasonalRates.find(
      (room) =>
        room.roomCategory ===
        roomType
    );

  if (!selectedRoom) {

    return {
      basePrice: 0,
      extraAdultPrice: 0,
      cwbPrice: 0,
      cnbPrice: 0,
    };
  }

  const selectedMeal =
    selectedRoom.mealPlans?.find(
      (meal) =>
        meal.mealPlan ===
        mealPlan
    );

  if (!selectedMeal) {

    return {
      basePrice: 0,
      extraAdultPrice: 0,
      cwbPrice: 0,
      cnbPrice: 0,
    };
  }

  return {

    basePrice:
      selectedMeal.rates
        ?.baseRate || 0,

    extraAdultPrice:
      selectedMeal.rates
        ?.extraAdultRate || 0,

    cwbPrice:
      selectedMeal.rates
        ?.childWithBedRate || 0,

    cnbPrice:
      selectedMeal.rates
        ?.childNoBedRate || 0,
  };
};

export default getHotelRate;
